<template>
  <div class="bjex-main">
    <!-- <div class="course-title text-left">课程安排</div>
    <div class="course-line"></div> -->
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-select
          @change="subjectChange"
          v-model="subject"
          clearable
          size="small"
          placeholder="学科"
          style="width: 100px"
        >
          <el-option
            v-for="item in subjectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          size="small"
          v-model="grade"
          @change="gradeChange"
          clearable
          placeholder="年级"
          style="width: 100px"
        >
          <el-option
            v-for="item in gradeList"
            :key="item.gradeId"
            :label="item.name"
            :value="item.gradeId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="type"
          @change="typeChange"
          clearable
          size="small"
          placeholder="课程类型"
          style="width: 100px"
        >
          <el-option
            v-for="item in typeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="save"
          size="small"
          @change="saveChange"
          clearable
          placeholder="状态"
          style="width: 100px"
        >
          <el-option
            v-for="item in saveList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="Limit"
          size="small"
          @change="LimitChange"
          clearable
          placeholder="范围"
          style="width: 100px"
        >
          <el-option
            v-for="item in courseLimit"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="classifyId"
          size="small"
          @change="ifyChange"
          clearable
          placeholder="分类"
          style="width: 100px"
        >
          <el-option
            v-for="item in classify"
            :key="item.id"
            :label="item.classifyName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="courseName"
          size="small"
          placeholder="请输入课程名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          @click.native="searchCourse"
          >搜索</el-button
        >
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click.native="editCourse(0)"
          >添加课程</el-button
        >
         <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          @click.native="exportExcel"
          >导出Excel</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      v-loading="state"
      :data="courseList"
      border
      :row-style="{ height: '48px' }"
      :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      stripe
      class="course-main"
    >
      <el-table-column
        type="index"
        label="序号"
        width="55"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="courseName"
        label="名称"
        min-width="250"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="subjectName"
        label="学科"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="gradeName"
        label="年级"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="schoolName"
        label="学校"
        min-width="200"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="courseSpeaker"
        label="主讲人"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column prop="code" label="课程类型" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.courseTypeid == 1 ? "直播" : "点播" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="classifyName"
        label="课程分类"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="courseHour"
        label="课时数"
        width="80"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.courseHour > 0 ? scope.row.courseHour : 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="courseHour"
        label="公开范围"
        width="165"
        align="center"
      >
        <template slot-scope="scope">
          <span> {{ limitData(scope.row.courseLimit) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="courseViewnum"
        label="浏览量"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="beginTime"
        label="直播开始时间"
        width="165"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="添加时间"
        width="165"
        align="center"
      ></el-table-column>
      <el-table-column prop="city" label="首页显示" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.courseRecomend == 1 ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="courseState"
        label="发布状态"
        width="80"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.courseState == 1 ? "已发布" : "存草稿" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="230" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button
            size="samll"
            type="text"
            @click.native="watchLive(scope.row)"
            >进入观看</el-button
          >
          <el-button
            size="samll"
            type="text"
            :disabled="isManager != 1 && scope.row.creatorId != userId && scope.row.roleType == 'group'"
            @click.native="editCourse(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="samll"
            type="text"
            style="color: #ff5151"
            :disabled="isManager != 1 && scope.row.creatorId != userId && scope.row.roleType == 'group'"
            @click.native="deleteCourse(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        background
        :hide-on-single-page="true"
        :current-page.sync="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="pagesize"
        layout="total, prev, pager, next, sizes, jumper"
        :total="totalcount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as homeApi from "@/api/home";
import { ERR_OK } from "@/api/index";
// import { mapState } from 'vuex'
//加密解密
// import utils from 'api/utils'
//日期格式化
// import moment from 'moment'
//自定义弹窗
// import OpenDialog from '@/components/OpenDialog'

export default {
  //   components: {
  //     'open-dialog': OpenDialog
  //   },
  data() {
    return {
      groupId: localStorage.getItem("groupId"),
      userId: localStorage.getItem('id'),
      isManager: localStorage.getItem('isManager'),
      courseName: "", //课程名称
      courseList: [], //课程列表
      page: 1, //当前页
      pagesize: 10, //每页显示数量
      totalcount: 0, //列表总数
      state: false, //加载状态
      pagelast: false, //是否最后一页
      subjectList: [], //学科列表
      subject: "", //学科选择
      gradeList: [], //年级列表
      grade: "", //年级选择
      typeList: [], //课程类型列表
      type: "", //类型选择
      saveList: [
        { id: 1, name: "存草稿" },
        { id: 2, name: "已发布" },
      ], //保存类型
      save: "", //保存类型选择
      courseLimit: [], // 公开范围
      Limit: "",
      classify: [], // 课程分类
      classifyId: "",
    };
  },
  created() {
    //初始化数据
    let page = this.$route.query.page
    if (!!page) {
      this.page = page
    }
    this.dataInit();
  },
  computed: {

  },
  methods: {
    //初始化数据
    dataInit() {
      //获取课程列表
      this.getCourseList();
      this.dictcode();
      this.courseclassify();
    },
    //获取学科列表
    getSubjectList() {
      //参数
      let params = {};
      let _this = this;
      //接口
      homeApi
        .getSubjectList(params)
        .then((res) => {
          let { data } = res;
          if (data.code === ERR_OK) {
            let list = data.data;
            //获取学科列表
            _this.subjectList = list;
            // _this.subjectList.unshift({
            //   id: "",
            //   name: "请选择学科",
            // });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 学科列表变化
    subjectChange() {
      this.getCourseList();
    },
    //获取年级列表
    getGradeList() {
      //参数
      let params = {
        schoolId: 0,
      };
      let _this = this;
      //接口
      homeApi
        .getGradeList(params)
        .then((res) => {
          let { data } = res;
          if (data.code === ERR_OK) {
            let list = data.data;
            //获取年级列表
            _this.gradeList = list;
            // _this.gradeList.unshift({
            //   gradeId: "",
            //   name: "请选择年级",
            // });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 年级列表变化
    gradeChange() {
      this.getCourseList();
    },
    // 发布状态变化
    saveChange() {
      this.getCourseList();
    },
    //获取课程类型列表
    getCourseTypeList() {
      //参数
      let params = {
        schoolId: 0,
      };
      let _this = this;
      //接口
      homeApi
        .getCourseTypeList(params)
        .then((res) => {
          let { data } = res;
          if (data.code === ERR_OK) {
            let list = data.data;
            //获取课程类型列表
            _this.typeList = list;
            // _this.typeList.unshift({
            //   id: "",
            //   name: "类型",
            // });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //  优客类型变化
    typeChange() {
      this.getCourseList();
    },
    // 获取课程分类
    courseclassify() {
      let that = this;
      homeApi
        .courseclassify()
        .then((res) => {
          that.classify = res.data.data;
        })
        .catch(() => {});
    },
    // 课程分类变化
    ifyChange(e) {
      this.classifyId = e;
      this.getCourseList();
    },
    // 获取公开范围
    dictcode() {
      let that = this;
      let params = {
        code: "courseLimit",
      };
      //接口
      homeApi
        .dictcode(params)
        .then((res) => {
          that.courseLimit = res.data.data;
        })
        .catch((error) => {});
    },
    // 公开范围变化
    LimitChange(e) {
      this.Limit = e;
      this.getCourseList();
    },
    // 公开范围数据处理
    limitData(id) {
      let name = "";
      this.courseLimit.forEach((item) => {
        if (item.code == id) {
          name = item.name;
        }
      });
      return name;
    },
    //获取课程列表
    getCourseList() {
      //参数
      let params = {
        groupId: this.groupId,
        curPage: this.page,
        pageSize: this.pagesize,
      };
      //学科
      if (this.subject > 0) {
        params.subjectId = this.subject;
      }
      //年级
      if (this.grade > 0) {
        params.gradeId = this.grade;
      }
      //课程类型
      if (this.type > 0) {
        params.courseTypeid = this.type;
      }
      //发布状态
      if (this.save > 0) {
        params.courseState = this.save - 1;
      }
      //课程名称
      if (this.courseName != "") {
        params.courseName = this.courseName;
      }
      //课程分类
      if (this.classifyId != "") {
        params.courseClassify = this.classifyId;
      }
      //范围
      if (this.Limit != "") {
        params.courseLimit = this.Limit;
      }
      this.state = true;
      let _this = this;
      //接口
      homeApi
        .getCourseList(params)
        .then((res) => {
          //关闭加载
          this.state = false;
          let { data } = res;
          if (data.code === ERR_OK) {
            //学校列表
            let list = data.data.dataList;
            _this.courseList = [];
            if (list.length > 0) {
              _this.totalcount = data.data.totalCount;
              _this.courseList = list;
            } else {
              _this.pagelast = true;
            }
          } else {
            _this.$toast.center(data.msg);
          }
          this.heights();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //改变每页显示数量
    handleSizeChange(val) {
      this.pagesize = val;
      this.getCourseList();
    },
    //跳转到第几页
    handleCurrentChange(val) {
      this.page = val;
      this.getCourseList();
    },
    //搜索主题
    searchCourse() {
      this.page = 1;
      this.getCourseList();
    },
    //编辑课程
    editCourse(v) {
      this.$router.push({
        path: "/addCourse",
        query: {
          id: v.courseId,
          page:this.page
        },
      });
      //   if (v.courseId) {
      //     //编辑课程
      //     this.$store.commit('UPDATE_COURSEINFO', v)
      //   } else {
      //     //新增课程
      //     this.$store.commit('REMOVE_COURSEINFO')
      //   }
      //   //跳转链接
      //   this.$emit('navlink', 'course-add')
    },
    //删除课程
    deleteCourse(v) {
      this.$confirm("确认删除课程么?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //参数
          let prarms = {
            id: v.courseId,
          };
          let _this = this;
          this.state = true;
          //接口
          homeApi
            .deleteCourse(prarms)
            .then((res) => {
              let { data } = res;
              _this.state = false;
              if (data.code === ERR_OK) {
                //重新获取列表
                _this.searchCourse();
                _this.$message.error("删除课程成功");
              }
            })
            .catch((error) => {
              _this.state = false;
            });
        })
        .catch(() => {});
    },
    //跳转链接
    openUrl(url) {
      //   this.$emit('navlink', url)
    },
    // 高度增加
    heights() {
      this.$nextTick(() => {
        setTimeout(() => {
          let height = document.getElementsByClassName(
            "el-table__fixed-right"
          )[0];
          if(height) {
            height.style.height = height.offsetHeight + 8 + "px";
          }
        });
      });
    },
    watchLive(row){
      if (row.courseTypeid == 1) {
        let url = homeApi.zxLive + row.lessonId
        window.open(url)
      }else{
        let urls = homeApi.zxIndex + row.lessonId
        window.open(urls)
      }
    },
    // 导出表格
    exportExcel(){
      let params = {
        courseTypeid:this.type,
        subjectId:this.subject,
        gradeId:this.grade,
        courseClassify:this.classifyId,
        courseState:this.save,
        courseLimit:this.Limit,
        groupId:this.groupId,
      }
      homeApi.exportCourseList(params,'课程列表')
    }
  },
  mounted() {
    //获取学科列表
    this.getSubjectList();
    //获取年级列表
    this.getGradeList();
    //获取课程类型列表
    this.getCourseTypeList();
    // el-table__fixed-right
  },
};
</script>

<style  scoped>
.course-title {
  font-size: 14px;
  font-weight: 700;
  font-family: "PingFang SC";
}
.course-line {
  border-top: 1px solid #e6e6e6;
  margin: 10px 0 5px 0;
}
.course-main {
  margin: 8px 0 5px 0;
  width: 100%;
}

.el-pagination__jump {
  margin-left: 0px;
}

.el-button {
  padding: 6px 10px;
  font-size: 14px;
}
.el-form .el-button {
  padding: 8px 10px;
  font-size: 12px;
}
.el-table .cell,
.el-form-item__label {
  font-size: 12px;
  color: #000;
}
.el-form-item {
  margin-bottom: 0px;
}
.el-form-item__content {
  line-height: 38px;
  font-size: 12px;
}
.el-select .el-input__inner,
.el-input--small .el-input__inner {
  height: 28px;
  line-height: 28px;
}
.page {
  margin-top: 20px;
}
.demo-form-inline {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/courseMan/courseList.vue